import React from 'react';
import * as PropTypes from 'prop-types';

import { Wrapper, Text } from './elements';

function SnBP001(props) {
  return (
    <Wrapper className={props.className}>
      <Text>{props.text}</Text>
    </Wrapper>
  );
}

SnBP001.propTypes = {
  className: PropTypes.string,
  text: PropTypes.string,
};

export default SnBP001;
